'use client'

import { useEffect, useState } from 'react'
import { useSearchParams } from 'next/navigation'
import { useRouter } from 'next/navigation'
import TypeformConsultationModal from '@/components/typeform-consultation-modal'

export default function ConsultationClient() {
  const searchParams = useSearchParams()
  const router = useRouter()
  const [propertySlug, setPropertySlug] = useState<string | null>(null)

  useEffect(() => {
    // Get property slug from URL parameter
    const property = searchParams.get('property')
    if (property) {
      setPropertySlug(property)
    }
  }, [searchParams])

  return (
    <>
      {/* Typeform-style consultation - renders inline with header/footer */}
      <TypeformConsultationModal
        isOpen={true}
        onClose={() => {
          // Navigate back to homepage
          router.push('/')
        }}
        source={propertySlug ? `property-${propertySlug}` : 'consultation-page'}
        inline={true}
      />
    </>
  )
}
